<div>
  <div class="modal-header">
    <h5 class="modal-title"
        id="syncDevicesModalLabel">Sync devices</h5>
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closingModal()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex p-2 bd-highlight">
      <form [formGroup]="syncDevicesForm"
            class="w-100">
        @if (locationSubset() === LocationSubset.All) {
          <div>All devices of this location are selected.<br /></div>
        }
        Please select the settings to sync.<br />
        <br />
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="Applications"
                 type="checkbox"
                 id="Applications" />
          <label class="form-check-label"
                 for="Applications"> Applications </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="NotificationProfiles"
                 type="checkbox"
                 id="NotificationProfiles" />
          <label class="form-check-label"
                 for="NotificationProfiles"> Notification Profiles </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="WifiProfiles"
                 type="checkbox"
                 id="WifiProfiles" />
          <label class="form-check-label"
                 for="WifiProfiles"
                 ngbTooltip="Syncing Wifi Profiles can only be done by admin users."
                 [disableTooltip]="userIsAdmin()">
            Wifi Profiles
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="EraApplicationConfiguration"
                 type="checkbox"
                 id="EraApplicationConfiguration" />
          <label class="form-check-label"
                 for="EraApplicationConfiguration"> Application Configurations </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="AppLockProfile"
                 type="checkbox"
                 id="AppLockProfile" />
          <label class="form-check-label"
                 for="AppLockProfile"> App Lock Profile </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="RestrictionsProfiles"
                 type="checkbox"
                 id="RestrictionsProfiles" />
          <label class="form-check-label"
                 for="RestrictionsProfiles"> Restrictions Profiles </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="DeviceName"
                 type="checkbox"
                 id="DeviceName" />
          <label class="form-check-label"
                 for="DeviceName"> Device Name </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="AirplaySecurityProfile"
                 type="checkbox"
                 id="AirplaySecurityProfile" />
          <label class="form-check-label"
                 for="AirplaySecurityProfile"> Airplay Security Profile </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="ConfigurationProfiles"
                 type="checkbox"
                 id="ConfigurationProfiles" />
          <label class="form-check-label"
                 for="ConfigurationProfiles"> Configuration Profiles </label>
        </div>
        <br />
        Apply sync with force?<br />
        <div class="form-check form-switch">
          <input class="form-check-input rounded-pill"
                 formControlName="ForceSync"
                 type="checkbox"
                 id="ForceSync" />
          <label class="form-check-label"
                 for="ForceSync"> Force </label>
        </div>
        @if (syncDevicesForm.invalid) {
          <div class="text-danger">* Please select at least one setting.</div>
        }
        <br />
        @if (syncDevicesForm.get('ForceSync')?.getRawValue()) {
          <div class="alert alert-warning p-2"
               role="alert">
            <h5><fa-icon icon="triangle-exclamation"></fa-icon> Warning</h5>
            <div>Applying the sync with force will also trigger the sync on devices in checked-in rooms.</div>
          </div>
        }
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-primary"
            (click)="toggleSelectAll()">
      {{ selectedAllSettings ? 'Deselect all settings' : 'Select all settings' }}
    </button>
    <button type="button"
            [disabled]="syncDevicesForm.invalid"
            class="btn btn-primary"
            (click)="onSubmit()">
      Sync devices
    </button>
  </div>
</div>